export default __webpack_public_path__ + "static/megan-34396b00fff1f92bd291ff21f14e4a1c.png";